import React, {useState, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {useRouter} from 'next/router';
import axios from 'axios';
import {saveVehicles, syncAccount} from '../rcaSlice';
import RCACarStart from './RCACarStart';
import RCAVehiclesList from './RCAVehiclesList';
import RCACarInfo from './car/CarInfo';
import RCAFormNotice from '../info/RCAFormNotice';
import RCABuyerInfo from '../info/RCABuyerInfo';
import RCALegalNotice from '../info/RCALegalNotice';
import {loadFormStorage, saveFormStorage} from '../../utils/compare/rcaForm';
import PersonalCookieNotice from '../../cookie/PersonalCookieNotice';
import { saveVehicleHelper } from '../../utils/compare/rcaForm';
import {mapVehicleFromServer, mergeUserVehicles} from '../../../components/utils/compare/rcaUtils';
import LoadingFullPage from '../../../components/elements/LoadingFullPage';

const RCACarFlow = (props) => {

    const {CSRFToken} = props;
    const [step, editStep] = useState('');
    const [activeVehicle, editActiveVehicle] = useState({});
    const [cookieAlert, editCookieAlert] = useState(false);
    const [isLoading, editIsLoading] = useState(false);

    const dispatch = useDispatch();
    const router = useRouter();
    const vehicles = useSelector( state => state.rca.vehicles);
    const vehiclesStatus = useSelector( state => state.rca.status);
    const syncVehicles = useSelector( state => state.rca.sync);
    const cookieState = useSelector( state => state.cookie);
    const user = useSelector( state => state.user);
    const isMounted = useRef(null);

    useEffect( ()=>{
       
        isMounted.current = true;
        let vehiclesData = vehicles;
        if (vehicles.length == 0) {
            const storageData = loadFormStorage();
            if (storageData) {
                vehiclesData = storageData;
                dispatch(saveVehicles({ vehicles: vehiclesData, status: 'init'}));
            }
        }
        editStep(vehiclesData.length >0 ? 'list': 'new'); 
        
        return ()=>{
            isMounted.current = false;
        }
        
    }, []);

    useEffect( ()=>{
        if (cookieState.status == 'success') {
            showCookieAlert();
        }
    }, [cookieState.status])

    useEffect ( ()=>{
        if (cookieState.categories.personal == 1 && vehiclesStatus == 'save') {
            saveFormStorage(vehicles);
        }
    }, [vehiclesStatus])

    useEffect( ()=>{
        if ( user.isLoggedIn && !syncVehicles ) {
            loadUserVehicles();
        }
    }, [user.isLoggedIn])


    const setActiveVehicle = (id) => {
        editActiveVehicle(vehicles[id]);
    }   

    const editCarInfo = () => {
        let newVehicles = vehicles.map( item => item.serie_sasiu == activeVehicle.serie_sasiu ? {...item, step: 'auto'} : item );
        const res = dispatch(saveVehicles({ vehicles: newVehicles, status: 'save'}));
        if (res) {
            router.push('/asigurari-rca/auto');
        }
    }

    const addNewCar = (vehicle) => {
        let newVehicle = {
            ...vehicle,
        };
        const newVehicles = saveVehicleHelper(newVehicle, vehicles);
        dispatch(saveVehicles({vehicles: newVehicles, status: 'save'}));
        router.push('/asigurari-rca/auto');
    }

    
    const showPanel = () => {
        let result;
        switch(step) {
            case 'new':
                result = 
                    <RCACarStart
                        vehiclesNumber={vehicles.length}
                        CSRFToken={CSRFToken}
                        editStep={editStep}
                        activeVehicle={activeVehicle}
                        editActiveVehicle={editActiveVehicle}
                        addNewCar={addNewCar}
                    />;
                break;
            case 'list':
                result = 
                    <RCAVehiclesList 
                        vehicles={vehicles}
                        editStep={editStep}
                        setActiveVehicle={setActiveVehicle}
                    />;
                break;
            case 'car-info':
                result = 
                    <RCACarInfo 
                        vehicle={activeVehicle}
                        CSRFToken={CSRFToken}
                        editStep={editStep}
                        vehiclesNumber={vehicles.length}
                        editCarInfo={editCarInfo}
                        
                    />;
                break;
        }
        return result;
    }

    const panel = showPanel();

    const showCookieAlert = () =>{
        if (cookieState && cookieState.status=='success' && cookieState.categories.personal == 0) {
            editCookieAlert(true);
        }
    }
    const closeCookieAlert = () => {editCookieAlert(false)}

    const loadUserVehicles = async () => {
        editIsLoading(true);
        try {
            const response = await axios({
                url: process.env.NEXT_PUBLIC_API + '/api/user/asigurari/rca/vehicles',
                method: 'get',
                withCredentials: true,
            });

            const data = response.data;
           
            if (isMounted.current) {
                if (data.status == 'success') {
                    const list = data.vehicles;
                    const userVehicles = list.map( item => mapVehicleFromServer(item.vehicle, item.resource, 'db'));
                    
                    const newVehicles = mergeUserVehicles(vehicles, userVehicles);
                    dispatch(syncAccount({vehicles: newVehicles}));
                    if (step == 'new') {
                        editStep('list');
                    }

                }
                editIsLoading(false);
            }
        } catch(err) {
            if (isMounted.current) {
                editIsLoading(false);
            }
        }
    }

    return (
        <>
        {isLoading && <LoadingFullPage />}
        { panel }
        { ( (step== 'new' && vehicles.length==0) || (step=='list')) && 
            <>
                <RCAFormNotice />
                <RCABuyerInfo />
                <RCALegalNotice />
            </>
        }
        {cookieAlert && 
            <PersonalCookieNotice 
                cookies={cookieState}
                close={closeCookieAlert}
            />
        }
        </>
    );
}

export default RCACarFlow;